
import React, { PureComponent } from 'react'
import { Modal, Col, Button } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import InputText from '../../commons/form/InputText'
import InputSelect from '../../commons/form/InputSelect'
import SimpleTablePage from '../../../containers/commons/general/SimpleTablePage'
import { handleKeyDown } from '../../../util/utils'

class CampaignGroupMasterModal extends PureComponent {
  constructor () {
    super()
    this.state = {}
  }

  submitCampaign (values) {
    let body = []
    Object.keys(values).map(item => {
      if (typeof values[item] === 'object') {
        body.push(values[item])
      }
    })
    body = {
      campaignGroupLanguage: body,
      campaignClassId: values.campaignClassId,
      groupCode: values.groupCode,
      campaignGroupId: this.props.campaignId,
      campaignGroupRoles: values.campaignGroupRoles
    }
    this.props.actions.submitCampaignGroup(body)
  }

  componentDidUpdate (prevProps) {
    if (this.props.showModal !== prevProps.showModal && this.props.showModal === true) {
      this.props.actions.fetchCampaignClass()
    }
  }

  render () {
    const {
      t, handleSubmit, languageList, nonEditableGroup, nonEditable,
      showModal,
      combos: { campaignClass, roleCombo }
    } = this.props
    const tKey = 'MASTERS.CAMPAIGN_GROUP_MASTERS.MODAL.'
    return (
      <Modal id="ampaingGroupMasterModal" className="_nf" show={showModal} onHide={this.props.actions.closeCampaignGroupMasterModal}>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitCampaign.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header closeButton onHide={this.props.actions.closeCampaignGroupMasterModal}>
            <Modal.Title>{t(`${tKey}TITLE`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="search-form">
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="campaignClassId"
                controlLabel={t(`${tKey}CLASS`)}
                placeholder={t(`${tKey}CLASS`)}
                valueKey="id"
                labelKey="value"
                options={campaignClass}
                disabled={nonEditableGroup}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="groupCode"
                controlLabel={t(`${tKey}CODE`)}
                placeholder={t(`${tKey}CODE`)}
                disabled={nonEditable}
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="campaignGroupRoles"
                id="campaignGroupRoles"
                controlLabel={t(`${tKey}ROLE_VERIFICATION`)}
                placeholder={t(`${tKey}ROLE_VERIFICATION`)}
                valueKey="id"
                labelKey="value"
                options={roleCombo}
                disabled={nonEditableGroup}
                multi={true}
              />

            </div>
            <SimpleTablePage
              // customClass={'langTable'}
              columns={[
                <th className='colWidth-15 alignC' key={2}>
                  {t('MASTERS.LANGUAGE')}
                </th>,
                <th className='colWidth-30' key={0}>
                  {t('MASTERS.NAME')}
                </th>,
                <th className='colWidth-55' key={1}>
                  {t('MASTERS.DESCRIPTION')}
                </th>
              ]}
              rows={languageList && languageList.map((val, idx) => (
                <tr key={idx}>
                  <td className='alignC'>
                    <p><span>{`${val.description}`}</span></p>
                    <p>{`(${val.name})`}</p>
                  </td>
                  <td>
                    <Field
                      component={InputText}
                      colWidth={100} // 25, 33, 50, 75, 100 default=25
                      name={`lang${val.languageId}.name`}
                      placeholder={t('MASTERS.NAME')}
                      maxLength={50}
                    />
                  </td>
                  <td>
                    <Field
                      component={InputText}
                      colWidth={100} // 25, 33, 50, 75, 100 default=25
                      name={`lang${val.languageId}.description`}
                      placeholder={t('MASTERS.DESCRIPTION')}
                      maxLength={100}
                    />
                  </td>
                </tr>
              ))}
            />
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} className="btn-wrapper">
              <Button
                id="role-modal-submit-button"
                className="_Btn new"
                type="submit"
                disabled={this.props.pristine}>
                {t(`${tKey}SUBMIT_BUTTON`)}
              </Button>
            </Col>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default reduxForm({
  form: 'editCampaignGroup',
  validate: (values, props) => {
    let error = {}
    if (values) {
      const tKey = 'MASTERS.CAMPAIGN_GROUP_MASTERS.VALIDATION.'
      if (!values.campaignClassId) {
        error.campaignClassId = props.t(`${tKey}CLASS`)
      }
      if (!values.campaignGroupRoles || values.campaignGroupRoles.length === 0) {
        error.campaignGroupRoles = props.t(`${tKey}ROLE_VERIFICATION`)
      }
      if (!values.groupCode) {
        error.groupCode = props.t(`${tKey}CODE`)
      }
      if (!values.name) {
        error.name = props.t(`${tKey}NAME`)
      }
      if (!values.description) {
        error.description = props.t(`${tKey}DESCRIPTION`)
      }
      props.languageList && props.languageList.forEach((element) => {
        let valueLangName = values['lang' + element.languageId].name
        let valueLangDesc = values['lang' + element.languageId].description
        let errorLang = {
          name: null,
          description: null
        }
        if (!valueLangName) {
          errorLang.name = props.t(`${tKey}NAME`)
        }
        if (!valueLangDesc) {
          errorLang.description = props.t(`${tKey}DESCRIPTION`)
        }
        error['lang' + element.languageId] = errorLang
      })
    }
    return Object.keys(error).length > 0 ? error : {}
  }
})(CampaignGroupMasterModal)
